import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { IPrevisionInterno, PrevisionInternoResponse, PrevisionInternoResult } from '@models/IPrevisiones';
import { MatInputModule } from "@angular/material/input";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { NGXLogger } from 'ngx-logger';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-prevision-interna-table',
  imports: [
    MatInputModule, CommonModule, FormsModule, MatDatepickerModule, MatCheckboxModule],
  templateUrl: './prevision-interna-table.component.html',
  styleUrl: './prevision-interna-table.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrevisionInternaTableComponent {

  previsionesResponseResultados = model<PrevisionInternoResponse | undefined>(undefined);
  initDay = input<Date>();
  lugar = input<string>('prevision');
  editable = input<boolean>(false);
  pedidos = model<IPrevisionInterno[]>([]);

  constructor(private logger: NGXLogger) { }

  eliminarPedido(pedido: IPrevisionInterno) {
    this.pedidos.update((previsiones) =>
      previsiones.map(p =>
        p.id === pedido.id
          ? { ...p, actionValor: 'B' }
          : p
      )
    );

    this.logger.info(this.pedidos());
  }

  editarPedido(pedido: IPrevisionInterno) {
    this.pedidos.update((previsiones) =>
      previsiones.map(p =>
        p.id === pedido.id
          ? { ...p, actionValor: 'E' }
          : p
      )
    );
  }



  fechaDisponible = (d: Date | null): boolean => {
    if (!d) return false;

    const date = new Date(d);
    date.setHours(0, 0, 0, 0); // quitar horas para comparar

    const hoy = this.initDay()!;
    hoy.setHours(0, 0, 0, 0);

    // Obtener lunes de esta semana
    const diaSemana = hoy.getDay(); // 0 = domingo, 1 = lunes
    const lunes = new Date(hoy);
    const diffToLunes = diaSemana === 0 ? -6 : 1 - diaSemana;
    lunes.setDate(hoy.getDate() + diffToLunes);

    // Obtener domingo de esta semana
    const domingo = new Date(lunes);
    domingo.setDate(lunes.getDate() + 6);

    return date >= lunes && date <= domingo;
  };

  isLineaKO(linea: IPrevisionInterno) {
    const isKo = this.previsionesResponseResultados()?.results?.some((r: PrevisionInternoResult) => r.pedido === linea.pedido && r.status === 'error');
    return isKo;
  }

  quitarLineaPedido(index: number) {
    this.pedidos.update((previsiones) =>
      previsiones.filter((p, i) => i !== index)
    );
  }

}
